




































import Vue from "vue";

import { BlockTitle } from "./blocks/BlockTitle";
import { Department } from "./blocks/Department";
import { Employee } from "./blocks/Employee";
import { Map } from "./blocks/Map";

import Col from "@/components/common/Col.vue";
import PageTitle from "@/components/common/PageTitle.vue";
import Row from "@/components/common/Row.vue";
import { cartModule, contactsModule } from "@/plugins/store-accessors";
import { IPageMeta } from "@/services/interfaces";

export default Vue.extend({
  name: "contacts-page",
  components: {
    Employee,
    Department,
    BlockTitle,
    PageTitle,
    Row,
    Column: Col,
    Map,
  },

  watch: {
    getMeta: (data: IPageMeta) => {
      document.title = data.title || "";
    },
  },

  computed: {
    getData() {
      return contactsModule.getData;
    },

    getMeta() {
      return contactsModule.getMeta;
    },
  },

  mounted() {
    cartModule.getCart();
    contactsModule.requestData();
    document.title = this.getMeta.title || "";
  },
});
